<template>
    <div>
        <div
            v-for="(f, index) in options"
            :key="f.id"
            class="toggle-button-list"
        >
            <input
                :id="`${uid}-${f.id}`"
                :checked="f.checked"
                :value="index"
                type="checkbox"
                @input="handleUpdate"
            />
            <label
                :for="`${uid}-${f.id}`"
                :data-test-id="`firmware-${f.label}`"
            >
                {{ f.label }}
            </label>
        </div>
    </div>
</template>

<script>
import { getCurrentInstance } from 'vue'

export default {
    props: {
        allValues: {
            type: Array,
            required: true,
        },
        selectedValues: {
            type: Array,
            required: true,
        },
    },
    computed: {
        options() {
            return this.allValues.map((item) => {
                const { id, version: label } = item
                return {
                    id,
                    label,
                    checked: this.selectedValues.includes(item.id),
                }
            })
        },
        uid() {
            return getCurrentInstance().uid
        },
    },
    methods: {
        handleUpdate(e) {
            const { value: index, checked } = e.target
            const { id } = this.allValues[index]
            let selectedItems = this.selectedValues.slice()

            if (checked) {
                selectedItems.push(id)
            } else {
                selectedItems = selectedItems.filter((itemId) => itemId !== id)
            }

            this.$emit('update', selectedItems)
        },
    },
}
</script>
<style scoped lang="scss">
.toggle-button-list {
    display: inline-block;
    user-select: none;

    &:not(:last-child) {
        margin: 0 5px 0 0;
    }

    label {
        opacity: 0.3;
        padding: 3px 5px;
        background-color: #212628;
        font-size: 0.8125rem;
        font-family: 'Avenir Heavy';
        border-radius: 3px;
        cursor: pointer;
    }

    input {
        position: absolute;
        left: -100vw;
    }

    input:checked + label {
        opacity: 1;
    }
}
</style>
